var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 16.5 16.5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.95833 15.75V13.25C5.95833 12.3295 6.70453 11.5833 7.625 11.5833H8.875C9.79547 11.5833 10.5417 12.3295 10.5417 13.25V15.75M15.75 6.86275V12.7251C15.75 14.3957 14.2576 15.75 12.4167 15.75H4.08333C2.24238 15.75 0.75 14.3957 0.75 12.7251V6.86275C0.75 5.95453 1.1997 5.09437 1.97488 4.51989L6.14155 1.43201C7.36859 0.522664 9.13141 0.522662 10.3584 1.43201L14.5251 4.51989C15.3003 5.09437 15.75 5.95453 15.75 6.86275Z",
    stroke: "var(--stroke-0, #4858A8)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.f9c16b4275c411f3939108c9cf636d94.svg";
export { ForwardRef as ReactComponent };